import React from "react";
import FormGeneric from "../../../../shared/components/generic/form/form-generic";
import TooltipGeneric from "../../../../shared/components/generic/tooltip/tooltip-generic";
import Input from "../../../../components/inputs/input";
import DashboardSection from "../../components/section/dashboard-section";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import { cycleFormConfig } from "../../config/header/cycle-form-config";
import {
    getCycleBaselineLabel,
    getGoalClassName,
    getGoalLabel
} from "../../utils/dashboard-status-utils";
import InlineAlert from "../../../../shared/components/generic/alert/inline-alert/inline-alert";
import "./dashboard-cycle-panel.css";

const DashboardCyclePanel = ({
    cycleOptions = [],
    selectedCycle = "",
    onCycleChange,
    referenceDateLabel = "-",
    simulateGrossValue = false,
    onSimulateGrossValueChange,
    isClosedCycle = false,
    cycleStatus = {},
    baselineClassName = "",
    installmentSummary = {}
}) => {
    const {
        discountPercentage = 0,
        isBelowBaseline = false,
        hasLatePaymentInPeriod = null,
        goals = {}
    } = cycleStatus;

    const {
        originalInstallmentValue = 0,
        discountProjectionValue = 0,
        finalInstallmentValue = 0
    } = installmentSummary;

    return (
        <DashboardSection columns="cycle" className="dashboard-cycle-panel">
            <div className="dashboard-cycle-panel__filters">
                <FormGeneric
                    formId="dashboard-cycle-form"
                    formFields={cycleFormConfig({
                        cycleOptions,
                        selectedCycle
                    })}
                    onSubmit={() => { }}
                    onFieldChange={({ name, value }) => {
                        if (name === "cycle" && typeof onCycleChange === "function") {
                            onCycleChange(value);
                        }
                    }}
                />

                <p className="dashboard-cycle-panel__reference-date">
                    <span>Data de referência:</span>
                    <strong>{referenceDateLabel}</strong>
                </p>

                <div className="dashboard-cycle-panel__gross-row">
                    <Input
                        type="checkbox"
                        name="simulateGrossValue"
                        id="dashboard-simulate-gross-value"
                        label="Simular valor bruto"
                        value={simulateGrossValue}
                        onChange={onSimulateGrossValueChange}
                        width="auto"
                    />

                    <TooltipGeneric
                        content="Ao escolher a opção de exibição por valor bruto, considere que os valores serão apenas representações estimadas e não resultados reais brutos."
                        iconSize={16}
                        placement="top"
                    />
                </div>

                {simulateGrossValue && (
                    <InlineAlert
                        variant="warning"
                        className="dashboard-cycle-panel__gross-warning"
                        message="Atenção: os valores brutos são estimativas e não representam valores reais."
                    />
                )}
            </div>

            <div className="dashboard-cycle-panel__projection">
                <div className="dashboard-cycle-panel__title-row">
                    <h3>
                        <span>
                            {isClosedCycle
                                ? "Percentual de desconto no ciclo:"
                                : "Projeção de percentual de desconto no ciclo:"}
                        </span>

                        <span className="dashboard-cycle-panel__discount-value">
                            <strong className="dashboard-percentage-pill">
                                {MonetaryUtils.formatPercentage(discountPercentage)}
                            </strong>

                            <TooltipGeneric
                                content="Opção para justificar resultado final."
                                iconSize={16}
                                placement="top"
                            />
                        </span>
                    </h3>
                </div>

                <p className="dashboard-cycle-panel__baseline">
                    <span>
                        {isClosedCycle
                            ? "Net Sales do grupo no ciclo:"
                            : "Projeção de Net Sales do grupo no ciclo:"}
                    </span>

                    <strong className={baselineClassName}>
                        {getCycleBaselineLabel(isBelowBaseline)}
                    </strong>
                </p>

                <div className="dashboard-cycle-panel__badges">
                    <span className={getGoalClassName(goals.minimumSales)}>
                        Meta mínima de Vendas:
                        <strong>{getGoalLabel(goals.minimumSales)}</strong>
                    </span>

                    <span className={getGoalClassName(goals.varilux)}>
                        Meta de Varilux:
                        <strong>{getGoalLabel(goals.varilux)}</strong>
                    </span>

                    <span className={getGoalClassName(goals.group)}>
                        Meta do Grupo:
                        <strong>{getGoalLabel(goals.group)}</strong>
                    </span>
                    {isClosedCycle && hasLatePaymentInPeriod !== null && (
                        <span
                            className={[
                                "dashboard-cycle-panel__badge",
                                hasLatePaymentInPeriod
                                    ? "dashboard-cycle-panel__badge--danger"
                                    : "dashboard-cycle-panel__badge--success"
                            ].join(" ")}
                        >
                            Inadimplência no período:
                            <strong>{hasLatePaymentInPeriod ? "Sim" : "Não"}</strong>
                        </span>
                    )}
                </div>
            </div>

            <aside className="dashboard-cycle-panel__installment-card">
                <p>
                    <span>Valor original da parcela:</span>
                    <strong>{MonetaryUtils.formatCurrency(originalInstallmentValue)}</strong>
                </p>

                <p>
                    <span>
                        {isClosedCycle
                            ? "Valor de desconto:"
                            : "Projeção de valor de desconto:"}
                    </span>
                    <strong>{MonetaryUtils.formatCurrency(discountProjectionValue)}</strong>
                </p>

                <p>
                    <span>
                        {isClosedCycle
                            ? "Valor final da parcela:"
                            : "Projeção de valor final da parcela:"}
                    </span>
                    <strong>{MonetaryUtils.formatCurrency(finalInstallmentValue)}</strong>
                </p>
            </aside>
        </DashboardSection>
    );
};

export default DashboardCyclePanel;